import React from "react";
import "./Skill.css";
const Skill = () => {
  return (
    <div>
      <section class="skills" id="skills">
        <div class="content">
          <div class="title">
            <span>My Skills</span>
          </div>
          <div class="skills-details">
            <div class="text">
              <div class="topic">Skills Reflects Our Knowledge</div>
              <p>
                The universe is full of magical things, patiently waiting for
                our wits to grow sharper
              </p>
              <div class="experience">
                <div class="num">2</div>
                <div class="exp">
                  Years Of <br /> Experience
                </div>
              </div>
            </div>
            <div class="boxes">
              <div className="progress-bar-section">
                <ul>
                  <li class="html">
                    <p className="">HTML</p> <p>95%</p>
                  </li>
                  <li class="css">
                    <p>CSS</p> <p>85%</p>
                  </li>
                  <li class="bootstrap">
                    <p>Bootstrap</p> <p>90%</p>
                  </li>
                  <li class="js">
                    <p>JavaScript</p> <p>75%</p>
                  </li>
                  <li class="ng">
                    <p>React</p> <p>70%</p>
                  </li>
                  <li class="node">
                    <p>Node</p> <p>40%</p>
                  </li>
                  <li class="express">
                    <p>Express JS</p> <p>60%</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Skill;
